import styles from './IppicaHeaderNumeroCorsa.module.scss';
import { useGetLabelsByKeys } from 'hooks/useLingUI';
import { useTypedSelector } from 'lib/centralStore';

export const IppicaHeaderNumeroCorsa = () => {
  const [labelCorsa, labelAntepost] = useGetLabelsByKeys(['corsa', 'antepost']);

  const { isAntepost, numeroCorsa } = useTypedSelector((state) => state.ippica.ippicaDetailRace!) || {
    isAntepost: null,
    numeroCorsa: null,
  };

  return (
    <p className={styles.paragraph}>
      {labelCorsa}
      <span className={`${styles.span} ${isAntepost ? styles.small : ''}`}>
        {isAntepost ? labelAntepost : numeroCorsa}
      </span>
    </p>
  );
};
